/*
const socials = [
	{
		icon: 'facebook-square',
		link: 'facebook.com',
	},
];
*/

const socials = [
	{
		icon: 'twitter-square',
		link: 'https://twitter.com/GunsonRoses',
	},
	{
		icon: 'instagram',
		link: 'https://www.instagram.com/djrizl/',
	},
	{
		icon: 'bandcamp',
		link: 'https://bradgunson.bandcamp.com/',
	},
	{
		icon: 'youtube',
		link: 'https://www.youtube.com/user/bradgunson',
	},
];

export default socials;



// WEBPACK FOOTER //
// ./src/components/Footer/social-map.js